<template>
  <div class="product-add">
    <!--form表单-->
    <el-form ref="form" :model="form" label-width="200px" size="small">
      <div class="common-form">支付方式设置</div>
      <el-form-item label="选择支付方式">
        <div v-for="(item, key, index) in platform" :key="index" :label="item.value">
          <div v-if="form.payType[key]">
            <div class="fb">{{ item.name }}</div>
            <el-checkbox-group v-model="form.payType[key].payType">
              <el-checkbox v-for="(pay_item,pay_index) in item.payType" :key="pay_index"
                           :label="payType[pay_item].value">{{ payType[pay_item].name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form-item>
      <div class="common-form">微信支付设置</div>

      <el-form-item label="微信支付应用编号 AppId">
        <el-input v-model="form.wxConfig.appId" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="商户类型">
        <el-select v-model="form.wxConfig.type" placeholder="请选择商户类型">
          <el-option label="单商户" :value="0"></el-option>
          <el-option label="服务商" :value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="微信支付商户号 MCHID">
        <el-input v-model="form.wxConfig.mchId" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="微信支付API版本">
        <el-select v-model="form.wxConfig.apiVersion" placeholder="请选择API版本">
          <el-option :label="'v2'" value="v2"></el-option>
          <el-option :label="'v3'" value="v3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="支付超时(分钟)">
        <el-input-number v-model="form.wxConfig.expireTime" class="max-w460"></el-input-number>
      </el-form-item>
      <el-form-item label="微信支付密钥 APIKEY ">
        <el-input type="textarea" :rows="10" v-model="form.wxConfig.mchKey" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="微信支付密钥 API V3密钥">
        <el-input type="textarea" :rows="10" v-model="form.wxConfig.apiV3Key" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="apiclient_key">
        <el-input type="textarea" :rows="15" v-model="form.wxConfig.privateKeyContent" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="apiclient_cert">
        <el-input type="textarea" :rows="15" v-model="form.wxConfig.privateCertContent" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">支付宝支付设置</div>
      <el-form-item label="支付宝 appid">
        <el-input v-model="form.alipayAppid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="支付宝公钥">
        <el-input v-model="form.alipayPublickey" :rows="4" class="max-w460" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="应用私钥">
        <el-input v-model="form.alipayPrivatekey" :rows="4" class="max-w460" type="textarea"></el-input>
      </el-form-item>

      <div class="common-form">拉卡拉支付设置</div>
      <el-form-item label="拉卡拉 appid">
        <el-input v-model="form.lakalaConfig.appId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="证书序列号">
        <el-input v-model="form.lakalaConfig.serialNo" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="网关地址">
        <el-input v-model="form.lakalaConfig.serverUrl" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户私钥">
        <el-input v-model="form.lakalaConfig.privateKeyContent" :rows="4" class="max-w460" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="平台证书">
        <el-input v-model="form.lakalaConfig.appCertContent" :rows="4" class="max-w460" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="验签公钥">
        <el-input v-model="form.lakalaConfig.publicCertContent" :rows="4" class="max-w460" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="加密密钥">
        <el-input v-model="form.lakalaConfig.sm4Key" :rows="4" class="max-w460" type="textarea"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import AppSettingApi from '@/api/appsetting.js';
import {deepClone, formatModel} from '@/utils/base.js'

export default {
  data() {
    return {
      form: {
        payType: [],
        wxConfig: {
          appId: '',
          mchId: '',
          appSecret: '',
          apiVersion: '',
          expireTime: 60,
          type: 0,
          mchKey: '',
          apiV3Key: '',
          privateKeyContent: '',
          privateCertContent: '',
        },
        lakalaConfig: {
          appId: '',
          serialNo: '',
          serverUrl: '',
          appCertContent: '',
          publicCertContent: '',
          expireTime: 60,
          type: 0,
          sm4Key: '',
          privateKeyContent: '',
          privateCertContent: '',
        },
        alipayAppid: '',
        alipayPublickey: '',
        alipayPrivatekey: '',
        p12: null
      },
      app: {},
      payType: [],
      platform: []
    };
  },
  created() {
    this.getData();
  },

  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      AppSettingApi.payDetail({}, true)
        .then(res => {
          self.app = res.data.app;
          self.payType = res.data.payType;
          self.platform = res.data.platform;
          self.form = formatModel(self.form, res.data.app);
          if (self.app.payTypeJson == null || self.app.payTypeJson == '') {
            self.form.payType = deepClone(res.data.platform);
          } else {
            self.form.payType = deepClone(self.app.payTypeJson);
            Object.keys(self.form.payType).forEach(function (key) {
              for (let i = 0; i < self.form.payType[key].payType.length; i++) {
                self.$set(self.form.payType[key].payType, i, parseInt(self.form.payType[key].payType[i]));
              }
            })
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //提交表单
    onSubmit() {
      let self = this;
      let params = self.form;
      params.wxConfig = self.form.wxConfig;
      AppSettingApi.editPay(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
        })
        .catch(error => {
        });
    },
    /*选择上传图片*/
    fileChange(e) {
      console.log(e);
    },

    /*选择图片之前*/
    onBeforeUploadP12(file) {
      return true;
    },

    /*上传图片*/
    UploadP12(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: '文件上传中,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const formData = new FormData();
      formData.append('iFile', param.file);
      AppSettingApi.uploadP12(formData)
        .then(response => {
          loading.close();
          self.$message({
            message: '本次上传文件成功',
            type: 'success'
          });
          param.onSuccess(); // 上传成功的图片会显示绿色的对勾
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: '本次上传文件失败',
            type: 'warning'
          });
          param.onError();
        });
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/appsetting/app/pay.vue